import React, { useEffect, useState } from 'react';
// if your current file is also in src/components/mixer/
import PartnerInputHeader from './Color Mixer UI Components/PartnerInputHeader';
import ColorCapsule from './Color Mixer UI Components/ColorCapsule';
import CodeInputRow from './Color Mixer UI Components/CodeInputRow';
import MixerPortalNavBar from './Color Mixer UI Components/MixerPortalNavBar'
import MinimalFooter from '../MinimalFooter';

const styles = {
    pageContainer: {
        fontFamily: "'Open Sans', sans-serif",
        maxWidth: 400,
        width: '100%', // ← add this line
        margin:'1rem auto',
        background: '#fff',
      },
  topRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },
  instructions: {
    fontSize: '1.1rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  timerBox: {
    padding: '0.5rem 1rem',
    borderRadius: 8,
    border: '1px solid #eee',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  },
  colorCard: (color) => ({
    width: '100%',
    height: 160,
    borderRadius: 12,
    backgroundColor: color === 'RED' ? '#ef4444' : '#2563eb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '1.2rem',
    fontWeight: 600,
    margin: '1.5rem 0',
  }),
  dividerRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1rem',
    fontSize: '0.9rem',
    color: '#555',
  },
  dividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: '#ddd',
    margin: '0 0.5rem',
  },
  formRow: {
    width: '100%',
    display: 'flex',
    gap: '0.5rem',
  },
  input: {
    flex: 1,
    padding: '0.75rem',
    borderRadius: 8,
    border: '1px solid #ccc',
    fontSize: '1rem',
    boxSizing: 'border-box',
  },
  button: {
    padding: '0.75rem 1rem',
    borderRadius: 8,
    backgroundColor: '#3b82f6',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
  },
};

export default function ColorRevealAndCodeInput({
  colour,
  endsAt,
  codeValue = '',
  onCodeSubmit,
  shouldShake,
  onShakeComplete,
}) {
  const [inputCode, setInputCode] = useState('');
  const effectiveCode = codeValue || inputCode;

  useEffect(() => {
    console.log("[ColorRevealAndCodeInput] codeValue prop received =>", codeValue);
    if (codeValue) {
      setInputCode(codeValue);
    } else {
      setInputCode('');
    }
  }, [codeValue]);

  useEffect(() => {
    console.log("[ColorRevealAndCodeInput] effectiveCode rendered =>", effectiveCode);
  }, [effectiveCode]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <MixerPortalNavBar />
      <PartnerInputHeader
        yourColour={colour}   // 👈 pass the actual user’s colour
        partnerColour={colour === 'RED' ? 'BLUE' : 'RED'}
        nextRoundStartsAt={endsAt}
      />
      <ColorCapsule colour={colour} />
      <div style={{ ...styles.pageContainer, flexGrow: 1 }}>
        <CodeInputRow
          code={effectiveCode}
          onChange={setInputCode}
          onSubmit={() => {
            onCodeSubmit(inputCode);
            setInputCode('');
          }}
          showSubmit={!codeValue}
          isReadOnly={!!codeValue}
          shouldShake={shouldShake}
          onShakeComplete={onShakeComplete}
        />
      </div>

      {/* Render footer only for the user who HAS the code (read-only view) */}
      {!!codeValue && <MinimalFooter />}
    </div>
  );
}
